import httpClient from "../../clients/httpClient";
import {
    IPortalUser,
    IPortalUserPayload,
    IPortalUsersResponse,
} from "../../interfaces/portal-user.interface";
import { GetPortalUsersPayload } from "../../state/types/portal-users";

const BASE_PATH = "/api/v1/admin/portal-users";

export const getPortalUsersRequest = (query: GetPortalUsersPayload) => {
    return httpClient.get<IPortalUsersResponse>(BASE_PATH, {
        params: {
            filter: query.filter,
            search: query.search || undefined,
            organization: query.organization || undefined,
            role: query.role || undefined,
            per_page: query.perPage,
            page: query.page,
            order_by: query.orderBy || undefined,
            direction: query.sortDirection || undefined,
        },
    });
};

export const getPortalUserRequest = (id: string) => {
    return httpClient.get<IPortalUser>(`${BASE_PATH}/${id}`);
};

export const editPortalUserRequest = (
    id: number,
    payload: IPortalUserPayload
) => {
    return httpClient.patch<IPortalUser>(`${BASE_PATH}/${id}`, payload);
};

export const deletePortalUserRequest = (id: number) => {
    return httpClient.delete(`${BASE_PATH}/${id}`);
};

// Honours the organization and search filters, but the server always scopes
// the CSV to portal users.
export const exportPortalUsersRequest = (params: {
    organization?: number;
    search?: string;
}) => {
    return httpClient.get<Blob>(`${BASE_PATH}/export`, {
        responseType: "blob",
        params: {
            organization: params.organization || undefined,
            search: params.search || undefined,
        },
    });
};
